import { render } from "./WhatsappInboxButton.vue?vue&type=template&id=3fc47f08"
import script from "./WhatsappInboxButton.vue?vue&type=script&lang=js"
export * from "./WhatsappInboxButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__